import * as constants from './constants';
import { guardNullOrUndefined } from '../utils/guards';

export const fetchAdsStart = () => ({ type: constants.FETCH_ADS_START });

export const fetchAdsSuccess = data => {
  guardNullOrUndefined(data);
  return { type: constants.FETCH_ADS_SUCCESS, data };
};

export const fetchAdsFailed = error => {
  guardNullOrUndefined(error);
  return {
    error,
    type: constants.FETCH_ADS_FAILED,
  };
};

export const fetchAdsCompleted = data => {
  guardNullOrUndefined(data);
  return { type: constants.FETCH_ADS_COMPLETED, data };
};

export const setSearchParams = (data, hasTermChanged = false) => {
  guardNullOrUndefined(data);
  return { type: constants.SET_SEARCH_PARAMS, data, hasTermChanged };
};

// forceNoAdpage -> force redirect to go to the original source, useful for "contact" button
// forceAdPage -> force redirect to go to the Adpage, useful when paginate on countries with no 100% of adpage
export const clickoutRequest = (ad, sectionId, sectionType, forceNoAdpage, forceAdpage = false) => {
  guardNullOrUndefined(ad);

  return {
    type: constants.CLICKOUT_REQUEST,
    payload: {
      ad,
      sectionId,
      sectionType,
      forceNoAdpage,
      forceAdpage,
    },
  };
};

export const clickoutStart = () => ({ type: constants.CLICKOUT_START });
export const clickoutSuccess = () => ({ type: constants.CLICKOUT_SUCCESS });

export const clickoutFailed = error => {
  guardNullOrUndefined(error);
  return { type: constants.CLICKOUT_FAILED, error };
};

export const fetchAutocompleteStart = () => ({ type: constants.FETCH_AUTOCOMPLETE_START });
export const fetchAutocompleteRequest = data => ({
  type: constants.FETCH_AUTOCOMPLETE_REQUEST,
  data,
});

export const fetchAutocompleteSuccess = data => {
  guardNullOrUndefined(data);
  return { type: constants.FETCH_AUTOCOMPLETE_SUCCESS, data };
};

export const fetchAutocompleteFailed = error => {
  guardNullOrUndefined(error);
  return { type: constants.FETCH_AUTOCOMPLETE_FAILED, error };
};

export const removeGeoId = () => ({ type: constants.REMOVE_GEO_ID });

export const activateUserSearchInteraction = () => ({
  type: constants.ACTIVATE_USER_SEARCH_INTERACTION,
});

export const resetSearchParamsToSerpSearch = () => ({
  type: constants.RESET_SEARCH_PARAMS_TO_SERP_SEARCH,
});

export const fetchAdsVisitCounter = () => ({
  type: constants.FETCH_ADS_VISIT_COUNTER,
});

export const setOrIncrementAdVisitCounter = adId => ({
  type: constants.SET_OR_INCREMENT_AD_VISIT_COUNTER,
  payload: adId,
});

export const setAdsVisitCounter = adsVisitCounter => ({
  type: constants.SET_ADS_VISIT_COUNTER,
  payload: adsVisitCounter,
});

export const redirectToAdSource = (ad, redirectUrl) => ({
  type: constants.REDIRECT_TO_AD_SOURCE,
  payload: {
    redirectUrl,
    ad,
  },
});

export const redirectToAdPage = ad => ({
  type: constants.REDIRECT_TO_AD_PAGE,
  payload: ad,
});

export const showRelatedAdsPopup = (ad, redirectUrl) => ({
  type: constants.SHOW_RELATED_ADS_POPUP,
  payload: {
    ad,
    redirectUrl,
  },
});

export const hideRelatedAdsPopup = () => ({
  type: constants.HIDE_RELATED_ADS_POPUP,
});

export const trackingRelatedAdsModal = isSemUrl => ({
  type: constants.TRACKING_RELATED_ADS_MODAL,
  payload: isSemUrl,
});

export const enableRetrackAdImpressions = () => ({
  type: constants.ENABLE_RETRACK_AD_IMPRESSIONS,
});

export const setSearchParamsPage = page => ({
  type: constants.SET_SEARCH_PARAMS_PAGE,
  payload: page,
});

export const initializeTypeId = verticalName => ({
  type: constants.INITIALIZE_TYPE_ID,
  payload: verticalName,
});

export const setShouldResetWhere = () => ({
  type: constants.SET_SHOULD_RESET_WHERE,
});

export const unsetShouldResetWhere = () => ({
  type: constants.RESET_SHOULD_RESET_WHERE,
});



// WEBPACK FOOTER //
// ./app/Serp/actions.js